import React, { useState, useCallback, useMemo } from 'react';
import { View, Modal, ScrollView, StyleSheet, Dimensions, Platform } from 'react-native';
import { Button, Text, Searchbar, useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';

const { width: screenWidth } = Dimensions.get('window');

interface Country {
  code: string;
  name: string;
}

interface CountryCodeSelectorProps {
  visible: boolean;
  onDismiss: () => void;
  onSelect: (code: string) => void;
  selectedCode: string;
}

export const ALL_COUNTRIES: Country[] = [
  { code: '+351', name: 'portugal' },
  { code: '+93', name: 'afghanistan' },
  { code: '+355', name: 'albania' },
  { code: '+213', name: 'algeria' },
  { code: '+376', name: 'andorra' },
  { code: '+244', name: 'angola' },
  { code: '+1', name: 'antiguaAndBarbuda' },
  { code: '+54', name: 'argentina' },
  { code: '+374', name: 'armenia' },
  { code: '+61', name: 'australia' },
  { code: '+43', name: 'austria' },
  { code: '+994', name: 'azerbaijan' },
  { code: '+1', name: 'bahamas' },
  { code: '+973', name: 'bahrain' },
  { code: '+880', name: 'bangladesh' },
  { code: '+1', name: 'barbados' },
  { code: '+375', name: 'belarus' },
  { code: '+32', name: 'belgium' },
  { code: '+501', name: 'belize' },
  { code: '+229', name: 'benin' },
  { code: '+975', name: 'bhutan' },
  { code: '+591', name: 'bolivia' },
  { code: '+387', name: 'bosniaAndHerzegovina' },
  { code: '+267', name: 'botswana' },
  { code: '+55', name: 'brazil' },
  { code: '+673', name: 'brunei' },
  { code: '+359', name: 'bulgaria' },
  { code: '+226', name: 'burkinaFaso' },
  { code: '+257', name: 'burundi' },
  { code: '+855', name: 'cambodia' },
  { code: '+237', name: 'cameroon' },
  { code: '+1', name: 'canada' },
  { code: '+238', name: 'capeVerde' },
  { code: '+236', name: 'centralAfricanRepublic' },
  { code: '+235', name: 'chad' },
  { code: '+56', name: 'chile' },
  { code: '+86', name: 'china' },
  { code: '+57', name: 'colombia' },
  { code: '+269', name: 'comoros' },
  { code: '+242', name: 'congo' },
  { code: '+506', name: 'costaRica' },
  { code: '+385', name: 'croatia' },
  { code: '+53', name: 'cuba' },
  { code: '+357', name: 'cyprus' },
  { code: '+420', name: 'czechRepublic' },
  { code: '+45', name: 'denmark' },
  { code: '+253', name: 'djibouti' },
  { code: '+1', name: 'dominica' },
  { code: '+1', name: 'dominicanRepublic' },
  { code: '+593', name: 'ecuador' },
  { code: '+20', name: 'egypt' },
  { code: '+503', name: 'elSalvador' },
  { code: '+240', name: 'equatorialGuinea' },
  { code: '+291', name: 'eritrea' },
  { code: '+372', name: 'estonia' },
  { code: '+251', name: 'ethiopia' },
  { code: '+679', name: 'fiji' },
  { code: '+358', name: 'finland' },
  { code: '+33', name: 'france' },
  { code: '+241', name: 'gabon' },
  { code: '+220', name: 'gambia' },
  { code: '+995', name: 'georgia' },
  { code: '+49', name: 'germany' },
  { code: '+233', name: 'ghana' },
  { code: '+30', name: 'greece' },
  { code: '+1', name: 'grenada' },
  { code: '+502', name: 'guatemala' },
  { code: '+224', name: 'guinea' },
  { code: '+245', name: 'guineaBissau' },
  { code: '+592', name: 'guyana' },
  { code: '+509', name: 'haiti' },
  { code: '+504', name: 'honduras' },
  { code: '+852', name: 'hongKong' },
  { code: '+36', name: 'hungary' },
  { code: '+354', name: 'iceland' },
  { code: '+91', name: 'india' },
  { code: '+62', name: 'indonesia' },
  { code: '+98', name: 'iran' },
  { code: '+964', name: 'iraq' },
  { code: '+353', name: 'ireland' },
  { code: '+972', name: 'israel' },
  { code: '+39', name: 'italy' },
  { code: '+1', name: 'jamaica' },
  { code: '+81', name: 'japan' },
  { code: '+962', name: 'jordan' },
  { code: '+7', name: 'kazakhstan' },
  { code: '+254', name: 'kenya' },
  { code: '+686', name: 'kiribati' },
  { code: '+82', name: 'koreaSouth' },
  { code: '+965', name: 'kuwait' },
  { code: '+996', name: 'kyrgyzstan' },
  { code: '+856', name: 'laos' },
  { code: '+371', name: 'latvia' },
  { code: '+961', name: 'lebanon' },
  { code: '+266', name: 'lesotho' },
  { code: '+231', name: 'liberia' },
  { code: '+218', name: 'libya' },
  { code: '+423', name: 'liechtenstein' },
  { code: '+370', name: 'lithuania' },
  { code: '+352', name: 'luxembourg' },
  { code: '+853', name: 'macau' },
  { code: '+389', name: 'macedonia' },
  { code: '+261', name: 'madagascar' },
  { code: '+265', name: 'malawi' },
  { code: '+60', name: 'malaysia' },
  { code: '+960', name: 'maldives' },
  { code: '+223', name: 'mali' },
  { code: '+356', name: 'malta' },
  { code: '+692', name: 'marshallIslands' },
  { code: '+222', name: 'mauritania' },
  { code: '+230', name: 'mauritius' },
  { code: '+52', name: 'mexico' },
  { code: '+691', name: 'micronesia' },
  { code: '+373', name: 'moldova' },
  { code: '+377', name: 'monaco' },
  { code: '+976', name: 'mongolia' },
  { code: '+382', name: 'montenegro' },
  { code: '+212', name: 'morocco' },
  { code: '+258', name: 'mozambique' },
  { code: '+95', name: 'myanmar' },
  { code: '+264', name: 'namibia' },
  { code: '+674', name: 'nauru' },
  { code: '+977', name: 'nepal' },
  { code: '+31', name: 'netherlands' },
  { code: '+64', name: 'newZealand' },
  { code: '+505', name: 'nicaragua' },
  { code: '+227', name: 'niger' },
  { code: '+234', name: 'nigeria' },
  { code: '+47', name: 'norway' },
  { code: '+968', name: 'oman' },
  { code: '+92', name: 'pakistan' },
  { code: '+680', name: 'palau' },
  { code: '+970', name: 'palestine' },
  { code: '+507', name: 'panama' },
  { code: '+675', name: 'papuaNewGuinea' },
  { code: '+595', name: 'paraguay' },
  { code: '+51', name: 'peru' },
  { code: '+63', name: 'philippines' },
  { code: '+48', name: 'poland' },
  { code: '+974', name: 'qatar' },
  { code: '+40', name: 'romania' },
  { code: '+7', name: 'russia' },
  { code: '+250', name: 'rwanda' },
  { code: '+966', name: 'saudiArabia' },
  { code: '+221', name: 'senegal' },
  { code: '+381', name: 'serbia' },
  { code: '+248', name: 'seychelles' },
  { code: '+232', name: 'sierraLeone' },
  { code: '+65', name: 'singapore' },
  { code: '+421', name: 'slovakia' },
  { code: '+386', name: 'slovenia' },
  { code: '+677', name: 'solomonIslands' },
  { code: '+252', name: 'somalia' },
  { code: '+27', name: 'southAfrica' },
  { code: '+211', name: 'southSudan' },
  { code: '+34', name: 'spain' },
  { code: '+94', name: 'sriLanka' },
  { code: '+249', name: 'sudan' },
  { code: '+597', name: 'suriname' },
  { code: '+268', name: 'swaziland' },
  { code: '+46', name: 'sweden' },
  { code: '+41', name: 'switzerland' },
  { code: '+963', name: 'syria' },
  { code: '+886', name: 'taiwan' },
  { code: '+992', name: 'tajikistan' },
  { code: '+255', name: 'tanzania' },
  { code: '+66', name: 'thailand' },
  { code: '+670', name: 'timorLeste' },
  { code: '+228', name: 'togo' },
  { code: '+676', name: 'tonga' },
  { code: '+1', name: 'trinidadAndTobago' },
  { code: '+216', name: 'tunisia' },
  { code: '+90', name: 'turkey' },
  { code: '+993', name: 'turkmenistan' },
  { code: '+688', name: 'tuvalu' },
  { code: '+256', name: 'uganda' },
  { code: '+380', name: 'ukraine' },
  { code: '+971', name: 'unitedArabEmirates' },
  { code: '+44', name: 'unitedKingdom' },
  { code: '+1', name: 'unitedStates' },
  { code: '+598', name: 'uruguay' },
  { code: '+998', name: 'uzbekistan' },
  { code: '+678', name: 'vanuatu' },
  { code: '+379', name: 'vaticanCity' },
  { code: '+58', name: 'venezuela' },
  { code: '+84', name: 'vietnam' },
  { code: '+967', name: 'yemen' },
  { code: '+260', name: 'zambia' },
  { code: '+263', name: 'zimbabwe' }
];

// Export list of codes for external parsing logic
export const COUNTRY_CODES: string[] = Array.from(new Set(ALL_COUNTRIES.map(c => c.code)));

export const CountryCodeSelector: React.FC<CountryCodeSelectorProps> = ({
  visible,
  onDismiss,
  onSelect,
  selectedCode,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState('');

  // Memoize the filtered countries to prevent unnecessary recalculations
  const filteredCountries = useMemo(() => {
    if (!searchQuery) return ALL_COUNTRIES;
    
    const query = searchQuery.toLowerCase();
    return ALL_COUNTRIES.filter(country => 
      t(`countries.${country.name}`).toLowerCase().includes(query) ||
      country.code.includes(query)
    );
  }, [searchQuery, t]);

  const handleSelect = useCallback((code: string) => {
    onSelect(code);
    setSearchQuery('');
    onDismiss();
  }, [onSelect, onDismiss]);

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      transparent={true}
      animationType="slide"
    >
      <View style={[styles.modalOverlay, { backgroundColor: 'rgba(0, 0, 0, 0.5)' }]}>
        <View style={[styles.modalContent, { backgroundColor: theme.colors.surface }]}>
          <View style={[styles.modalHeader, { borderBottomColor: theme.colors.outline }]}>
            <Text variant="titleLarge" style={{ marginBottom: 16, color: theme.colors.onSurface }}>
              {t('selectCountry')}
            </Text>
            <Searchbar
              placeholder={t('searchCountry')}
              onChangeText={setSearchQuery}
              value={searchQuery}
              style={{ 
                margin: 0, 
                elevation: 0, 
                backgroundColor: theme.colors.surfaceVariant 
              }}
              iconColor={theme.colors.onSurfaceVariant}
              inputStyle={{ color: theme.colors.onSurfaceVariant }}
              placeholderTextColor={theme.colors.onSurfaceVariant}
            />
          </View>
          <ScrollView style={styles.countryList}>
            {/* Portugal at the top */}
            <Button
              mode="text"
              onPress={() => handleSelect('+351')}
              style={[
                styles.countryButton,
                { backgroundColor: theme.colors.surface }
              ]}
              textColor={theme.colors.onSurface}
            >
              {`${t('countries.portugal')} (+351)`}
            </Button>
            {/* Rest of countries filtered by search */}
            {filteredCountries.map(country => (
              <Button
                key={`${country.code}-${country.name}`}
                mode="text"
                onPress={() => handleSelect(country.code)}
                style={[
                  styles.countryButton,
                  { backgroundColor: theme.colors.surface }
                ]}
                textColor={theme.colors.onSurface}
              >
                {`${t(`countries.${country.name}`)} (${country.code})`}
              </Button>
            ))}
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  modalContent: {
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    height: '80%',
    padding: 16,
    ...(Platform.OS === 'web' ? {
      maxWidth: 500,
      width: '90%',
      alignSelf: 'center',
    } : {}),
  },
  modalHeader: {
    borderBottomWidth: 1,
    paddingBottom: 16,
    marginBottom: 8,
  },
  countryList: {
    flex: 1,
  },
  countryButton: {
    justifyContent: 'flex-start',
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
}); 